import useInput from "hooks/useInput";
import { CheckboxField as IParqueCheckboxField } from "iparque-components";
import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: React.ReactNode;
  required?: boolean;
}

const CheckboxField: React.FC<Props> = ({
  type,
  id,
  name,
  label,
  ...props
}) => {
  const { field, meta, hasError } = useInput<boolean>(name);

  return (
    <IParqueCheckboxField
      id={id}
      label={label}
      error={hasError}
      helperText={hasError ? meta.error : ""}
      checked={field.value}
      {...field}
      {...props}
    />
  );
};

export default CheckboxField;
